/* global $: false */
'use strict';

/**
 * Read More Toggler
 */
$.fn.readMoreToggler = function() {
	let readMoreToggle = $(this),
		entryContent = $(this).parent().find('.entry-content'),
		readMoreToggleLink = readMoreToggle.find('.read-more-toggle-link'),
		entryContentHeight = entryContent.height(),
		entryContentMaxHeight = readMoreToggleLink.attr('data-max-height');

	if ( entryContentHeight > entryContentMaxHeight ) {
		entryContent.css('max-height', entryContentMaxHeight + 'px' ).addClass('faded');
		readMoreToggle.removeClass('d-none').addClass('d-inline-block');
		readMoreToggleLink.on('click', function(e) {
			e.preventDefault();
			$(this).toggleClass('toggled');
			if ($(this).hasClass('toggled')) {
				$(this).text($(this).attr('data-close-text'));
			}
			else {
				$(this).text($(this).attr('data-open-text'));
			}
			entryContent.toggleClass('toggled');
		});
	}
};
